var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMenuGenreIcon = function SvgMenuGenreIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "main-color-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108772",
    d: "M21.745 5.15A5.15 5.15 0 1 1 16.595 0a5.15 5.15 0 0 1 5.15 5.15"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108773",
    d: "M2.003 0h6.295a2.152 2.152 0 0 1 2 2v6.295a2 2 0 0 1-2 2H2.003a2.152 2.152 0 0 1-2-2V2a2 2 0 0 1 2-2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108774",
    d: "M2.003 11.443h6.295a2.152 2.152 0 0 1 2 2v6.295a2 2 0 0 1-2 2H2.003a2.152 2.152 0 0 1-2-2v-6.295a2 2 0 0 1 2-2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108775",
    d: "M13.447 11.443h6.294a2.152 2.152 0 0 1 2 2v6.295a2 2 0 0 1-2 2h-6.294a2.152 2.152 0 0 1-2-2v-6.295a2 2 0 0 1 2-2Z"
  })));
};
export default SvgMenuGenreIcon;